import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm07 from "../data/form07.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form07: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave07, setInputValueFormLeave07] = useState({
    information: {
      reason_quit: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave07.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave07]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave07({
        information: data.condition,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm07}
      inputValue={inputValueFormLeave07}
      setInputValue={setInputValueFormLeave07}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form07;
